export const environment = {
  production: false,
  baseUrl: 'https://stage.kafineteiran.com/api/v1',
  baseUrlV2: 'https://stage.kafineteiran.com/api/v2',
  socketUrl: 'https://stage.kafineteiran.com',
  firebase: {
    apiKey: 'AIzaSyBIqN3CrDjwH2PitrcgK6popURnaVvRkZE',
    authDomain: 'kafineteiran-2024.firebaseapp.com',
    projectId: 'kafineteiran-2024',
    storageBucket: 'kafineteiran-2024.firebasestorage.app',
    messagingSenderId: '503130877490',
    appId: '1:503130877490:web:82be6afbc9011a07cc162b',
    measurementId: 'G-56TQ1MC0TF',
    vapidKey:
      'BFRu34UEPVTwwqfzA6LjxpBGOvZO_85gK2PBvG8ZtdFwL5iOnzdRCjjziYd4_jt-PZtAo43yqsCuyzNYbPExwTE',
  },
};
